export default __webpack_public_path__ + "static/media/to_standard_icon.627915de.png";